import { useSyncViewportLayout } from '@hooks/useViewportLayout'
import { useUiPresentationStore } from '@store'
import { DesktopChrome } from './DesktopChrome'
import { TouchChrome } from './TouchChrome'

/**
 * Elige chrome según layout. Desktop = UI histórica.
 * tabletH / tabletV / mobile = TouchChrome (canvas + sheets).
 * El Canvas Three.js NO se monta aquí.
 */
export function ResponsiveShell() {
  useSyncViewportLayout()
  const layout = useUiPresentationStore((s) => s.layout)

  if (layout === 'desktop') {
    return <DesktopChrome />
  }

  return <TouchChrome />
}
